import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Button from 'components/Form/Button'
import useI18n from 'hooks/useI18n'

import {
  PromptActions,
  PromptBadge,
  PromptCountdown,
  PromptCountdownCopy,
  PromptCountdownValue,
  PromptEyebrow,
  PromptInner,
  PromptTitle,
  PromptRoot,
} from './styled'

const AUTO_OPEN_SECONDS = 8

export default function SurveyVideoPrompt({ onDismiss, onOpen, survey }) {
  const { t } = useI18n()
  const [seconds, setSeconds] = useState(AUTO_OPEN_SECONDS)

  useEffect(() => {
    let remaining = AUTO_OPEN_SECONDS
    setSeconds(remaining)

    const timer = window.setInterval(() => {
      remaining -= 1
      setSeconds(Math.max(remaining, 0))

      if (remaining <= 0) {
        window.clearInterval(timer)
        onOpen()
      }
    }, 1000)

    return () => window.clearInterval(timer)
  }, [onOpen, survey?.id])

  return (
    <PromptRoot
      aria-labelledby="survey-video-prompt-title"
      aria-modal="true"
      role="dialog"
    >
      <PromptInner>
        <PromptBadge>{t('survey_course_completed')}</PromptBadge>
        <PromptEyebrow>
          {t('survey_next_step')}: {survey?.title}
        </PromptEyebrow>
        <PromptTitle id="survey-video-prompt-title">
          {t('survey_share_experience')}
        </PromptTitle>

        <PromptCountdown aria-live="polite">
          <PromptCountdownValue>{seconds}</PromptCountdownValue>
          <PromptCountdownCopy>
            {t('survey_opens_in')} {seconds} {t('survey_seconds')}
          </PromptCountdownCopy>
        </PromptCountdown>

        <PromptActions>
          <Button color="blue" nospace width="100%" onClick={onOpen}>
            {t('survey_answer_now')}
          </Button>
          <Button color="white" nospace outline width="100%" onClick={onDismiss}>
            {t('survey_stay_here')}
          </Button>
        </PromptActions>
      </PromptInner>
    </PromptRoot>
  )
}

SurveyVideoPrompt.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  survey: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    title: PropTypes.string,
  }).isRequired,
}
